import { FC, useMemo } from 'react'

// COMPONENTS
import { Column } from '@components/templates/column'
import CurrencyTextField from '@components/molecules/currency-textfield'
import PledgeCell from '@components/molecules/pledge-cell'
import Button from '@components/atoms/button'

// TYPES
import { Form, useNavigate, type RouteObject } from 'react-router-dom'

// UTILITIES
import { max } from '@constants'
import { toPennies } from '@utils/number-helper'
import { useCurrencyInput } from '@hooks/inputs'
import { useGroupLoaderData, usePledgeOutletContext } from '../..'


interface Props { }

const formId = 'group-create-pledge-default'
const Component: FC<Props> = () => {
    const group = useGroupLoaderData()
    const [{ pledge, setupIntent }, setState] = usePledgeOutletContext()
    const { amount: storedAmount, paymentMethod } = pledge
    const [pledgeAmount, pledgeAmountProps] = useCurrencyInput({
        initValue: `${storedAmount || ''}`,
        max: max,
        onBlur: (amount) => setState((currentState) => ({ ...currentState, pledgeAmount: amount }))
    })
    const submitable = useMemo(() => (!!pledgeAmount && toPennies(pledgeAmount) >= 100), [pledgeAmount])
    const navigate = useNavigate()

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setState((currentState) => ({ ...currentState, pledgeAmount: toPennies(pledgeAmount) / 100 }))
        if (submitable) navigate((!paymentMethod || !setupIntent) ? 'pm' : 'review')
        else throw new Error(`Pledge Amounts must be more than $1`)
    }

    function handleBack() {
        navigate(-1)
    }

    return (<>
        <Column.Header.Start>
            <a onClick={handleBack}>
                <img src="/icons/arrow-left.svg" alt="back" style={{ width: '1.4rem', height: '1.4rem' }} draggable="false" />
            </a>
        </Column.Header.Start>
        <Form id={formId} onSubmit={handleSubmit} className="flex flex-col gap-4">
            <h2>I'm Willing to Pay Up to…</h2>
            <CurrencyTextField {...pledgeAmountProps} />
        </Form>
        {(!group.pledges?.length) && (
            <div className="flex flex-col gap-4">
                <h2>Groups Payments</h2>
                <p className="text-body-2" style={{ color: 'var(--splitcard-gray-500)' }}>These are commited amounts not final charges</p>
                {group.pledges?.map((pledge, index) => <PledgeCell key={`${pledge.user?.id}-${index}`} pledge={pledge} group={group} />)}
            </div>
        )}
        <Column.Footer>
            <Button form={formId} type="submit" disabled={!submitable}>Next</Button>
        </Column.Footer>
    </>)
}

const PledgeDefaultRoute: RouteObject = {
    index: true,
    Component,
}

export { PledgeDefaultRoute }